import React, { HTMLAttributes } from 'react';
import { BiProps } from './ComponentProps';
import { useBiClickLogger } from '../hooks/useBiClickLogger';

export interface BiDivProps extends HTMLAttributes<HTMLDivElement>, BiProps {}

const BiDiv: React.FC<BiDivProps> = ({ biData, innerRef, stopPropagation, ...rest }) => {
  const { setTrackingRef } = useBiClickLogger(biData, stopPropagation);
  return (
    <div
      ref={node => {
        setTrackingRef(node);
        innerRef && innerRef(node);
      }}
      {...rest}
    />
  );
};
BiDiv.displayName = 'BiDiv';

export default BiDiv;
